import { BaseComponent } from '../base-component.js';

export class AgBadge extends BaseComponent {
  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<span class="ag-badge"><slot></slot></span>`;
  }
}

customElements.define('ag-badge', AgBadge);
